import i18n from '../i18n';

/** Split admin key "beta.bannerTitle" → { namespace: "beta", key: "bannerTitle" } */
export function parseI18nAdminKey(fullKey) {
    const parts = String(fullKey || '').split('.');
    if (parts.length < 2) return { namespace: null, key: null };
    return { namespace: parts[0], key: parts.slice(1).join('.') };
}

/**
 * Apply saved translations to the running i18n instance (no page reload).
 * Updates both the named namespace and the flat translation bundle when present.
 */
export function applyI18nKeyTranslations(fullKey, translations) {
    const { namespace, key } = parseI18nAdminKey(fullKey);
    if (!namespace || !key || !translations) return;

    for (const [lang, value] of Object.entries(translations)) {
        if (value == null || value === '') continue;
        const code = lang === 'pt-BR' ? 'pt-BR' : lang;
        i18n.addResource(code, namespace, key, value, { silent: false });
        i18n.addResource(code, 'translation', `${namespace}.${key}`, value, { silent: false });
    }

    i18n.emit('languageChanged', i18n.language);
}
